import { useEffect, useRef } from "react";
import { useLocation } from "react-router";
import { PopoverClose } from "@altek/ui/components/ui/Popover";

/**
 * ÜST ÇUBUĞUN AÇILIR PANELİ GEZİNMEDE KAPANIR (8 Ekim 2026, kullanılabilirlik turu).
 *
 * Profil menüsünden «Profilim»e basan kişi yeni sayfaya geçiyordu ama menü AÇIK kalıyordu
 * (`data-state="open"`): panel yeni sayfanın üstünde asılı duruyor, kapatmak için bir kez daha
 * basmak gerekiyordu. Kitin `ProfileMenu`'sü kendini bilerek kapatmıyor («the caller closes its
 * own layer») ve `AppNavbar` panellerin açık durumunu dışarı vermiyor — yani kapatma ancak panelin
 * İÇİNDEN yapılabilir. Kit bunun için `PopoverClose`'u veriyor; bu bileşen onu görünmez bir düğme
 * olarak panele koyuyor ve adres değiştiği an basıyor.
 *
 * NEDEN SATIRA DEĞİL ADRESE BAĞLI: paneli kapatması gereken şey «bir satıra basıldı» değil
 * «sayfa değişti» — geri tuşu, bir kısayol, panelin içindeki bir bağlantı. `location.key` her
 * gezinmede yeni, aynı adrese yapılan gezinmede bile.
 *
 * Radix kapanınca odağı tetiğe (profil düğmesine) geri veriyor; gezinmeyle sökülen bir satırda
 * odak `<body>`'ye düşmüyor.
 */
export function CloseOnNavigation() {
  const { key } = useLocation();
  const openedAt = useRef(key);
  const close = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (key !== openedAt.current) close.current?.click();
  }, [key]);

  return <PopoverClose ref={close} hidden tabIndex={-1} aria-hidden="true" />;
}
